// extracted by mini-css-extract-plugin
export var region = "mapRegion-module--region--IUM2P";
export var regionsWrap = "mapRegion-module--regionsWrap--3RkQC";
export var regionSelected = "mapRegion-module--regionSelected--xSQkx";